import { render } from "./Centers.vue?vue&type=template&id=36aa7d68&scoped=true"
import script from "./Centers.vue?vue&type=script&lang=js"
export * from "./Centers.vue?vue&type=script&lang=js"

import "./Centers.vue?vue&type=style&index=0&id=36aa7d68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36aa7d68"

export default script